import useUserInfo from "@hooks/userInfo";
import { useUserName } from "@hooks/userInfo/index";
import IconMan from "@assets/imgs/icon-man.png";
import { twMerge } from "tailwind-merge";

interface UserAvatarProps {
  className?: string;
}

export default function UserAvatar({ className }: UserAvatarProps) {
  const { userInfo } = useUserInfo();
  const avatarUrl = userInfo.avatarUrl;
  const userName = useUserName();

  const style: any = {};
  if (avatarUrl) {
    style["backgroundImage"] = `url(${avatarUrl})`;
  } else if (!!userName) {
    style["backgroundColor"] = "#1AC3E9";
  } else {
    style["backgroundColor"] = `url(${IconMan})`;
  }

  return (
    <div
      className={twMerge(
        "text-white bg-no-repeat bg-center font-bold flex items-center justify-center rounded-full bg-cover text-[28px] w-[56px] h-[56px]",
        className,
      )}
      style={style}
    >
      {!avatarUrl && userName && userName.charAt(0).toUpperCase()}
    </div>
  );
}
